module.exports = __webpack_public_path__ + "media/images/home/ic_delete-16c85f861a238d2cce75b52ff6815859.svg";